import { add } from "date-fns";

import { THORCHAIN_BLOCK_TIME, type ThornodeDetails } from "../external";
import { invariant } from "../helpers";
import { parseListing } from "./parseListing";
import { parseThorname } from "./parseThorname";

export class ForgeModels {
  thornodeDetails: ThornodeDetails;
  runeUSDPrice: number;

  constructor({
    thornodeDetails,
    runeUSDPrice,
  }: {
    thornodeDetails: ThornodeDetails;
    runeUSDPrice: number;
  }) {
    invariant(thornodeDetails, "Can't create ForgeModels instance without 'thornodeDetails'");
    invariant(runeUSDPrice, "Can't create ForgeModels instance without 'runeUSDPrice'");

    this.thornodeDetails = thornodeDetails;
    this.runeUSDPrice = runeUSDPrice;
  }

  getDateFromExpiryBlockHeight = (expiryBlockHeight: string) => {
    const blocksLeft = Number.parseInt(expiryBlockHeight) - this?.thornodeDetails?.blockHeight;

    const expiresAt = add(this.thornodeDetails?.latestTime, {
      seconds: blocksLeft * THORCHAIN_BLOCK_TIME,
    });

    return expiresAt;
  };

  parseListing = parseListing(this);
  parseThorname = parseThorname(this);
}
